import { Divider } from "@oxygen/core";
import { CarKey, Edit, Car, Logout, Notes } from "@oxygen/icons";
import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../actionCreator";
import {
  MY_CAR_LISTINGS_URL,
  MY_CARWALE_URL,
  CHANGE_PASSWORD_URL,
  EDIT_PROFILE_URL,
} from "../constants";
import { initToast } from "GlobalActionCreator/Toast";
import CarwaleLoginApi from "../apis";
import { makeCancelable } from "GlobalUtils/CancelablePromise";
import { CSSFlex } from "GlobalComponent/CSSCore";
import getThemeClasses from "@oxygen/theme";
import styles from "./scss/AccountOptions.module.scss";

const optionTextClasses = getThemeClasses(`
  ml-4;
  font-size-7.5;
  cursor-pointer;
  color-charcoal;
`);
const optionWrapperClasses = getThemeClasses(`
  mt-6;
  align-items-center;
`);
const Option = ({
  icon: Icon,
  text,
  to,
  onClick,
  className = optionWrapperClasses,
}) => {
  const TextComponent = to ? "a" : "span";
  return (
    <CSSFlex className={className}>
      <Icon size="lg" />
      <TextComponent className={optionTextClasses} href={to} onClick={onClick}>
        {text}
      </TextComponent>
    </CSSFlex>
  );
};

const carListingClasses = getThemeClasses(`
  mt-0;
  align-items-center;
`);
const userNameClasses = getThemeClasses(`
  font-size-7.5;
  mt-2;
  mb-2;
  text-align-center;
`);
const editContainerClasses = getThemeClasses(`
  align-items-center;
  justify-content-center;
  color-blue-light;
  mb-3;
  cursor-pointer;
`);
const editProfileClasses = getThemeClasses(`
  font-weight-bold;
  font-size-6.5;
  mr-2;
`);
const optionsWrapperClasses = getThemeClasses(`
  pl-4;
  pr-4;
  pt-4;
  pb-5;
`);
const dividerClasses = getThemeClasses(`
  pl-3;
  pr-3;
`);

/**
 * This component renders Account Options when an user
 * is already loggedin
 * Handles logout functionality
 */
let apiPromise = null;

export const AccountOptions = memo(function AccountOptions() {
  const { userInfo } = useSelector(state => state.account || {});
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      apiPromise && apiPromise.cancel();
    };
  }, []);

  const handleLogout = () => {
    apiPromise && apiPromise.cancel();
    apiPromise = makeCancelable(CarwaleLoginApi.cwLogout());
    apiPromise.promise
      .then(() => {
        dispatch(logOut());
        dispatch(initToast({ message: "You have been logged out" }));
      })
      .catch(err => {
        console.log("Error in Logout api", err);
        dispatch(initToast({ message: "Something went wrong" }));
      });
  };

  return (
    <div className={styles.container}>
      <div className={userNameClasses}>{userInfo.name}</div>
      <CSSFlex as="a" className={editContainerClasses} href={EDIT_PROFILE_URL}>
        <span className={editProfileClasses}>Edit Profile</span>
        <Edit size="sm" />
      </CSSFlex>
      <Divider className={dividerClasses} style={{ marginLeft: "-12px" }} />
      <div className={optionsWrapperClasses}>
        <Option
          icon={Notes}
          text="Manage my car listing"
          to={MY_CAR_LISTINGS_URL}
          className={carListingClasses}
        />
        <Option icon={Car} text="My CarWale" to={MY_CARWALE_URL} />
        <Option icon={CarKey} text="Change Password" to={CHANGE_PASSWORD_URL} />
        <Option icon={Logout} text="Log out" onClick={handleLogout} />
      </div>
    </div>
  );
});
